export interface SubService {
  slug: string;
  label: string;
  icon: string;
}

export interface Trade {
  slug: string;
  label: string;
  pluralLabel: string;
  serviceTypeValue: string;
  subServices: SubService[];
  enabled: boolean;
}

export const TRADES: Trade[] = [
  {
    slug: 'locksmith',
    label: 'Locksmith',
    pluralLabel: 'Locksmiths',
    serviceTypeValue: 'Locksmith',
    subServices: [
      { slug: 'home', label: 'Home', icon: 'Home' },
      { slug: 'vehicle', label: 'Vehicle', icon: 'Car' },
    ],
    enabled: true,
  },
  {
    slug: 'vehicle-recovery',
    label: 'Vehicle Recovery',
    pluralLabel: 'Vehicle Recovery Services',
    serviceTypeValue: 'Vehicle Recovery',
    subServices: [],
    enabled: true,
  },
  // Future trades (disabled for now):
  // { slug: 'plumber', label: 'Plumber', serviceTypeValue: 'Plumber', subServices: [...], enabled: false },
];

export function getTradeBySlug(slug: string): Trade | undefined {
  return TRADES.find((t) => t.slug === slug);
}

export function getEnabledTrades(): Trade[] {
  return TRADES.filter((t) => t.enabled);
}
